export type BrowserLogCandidate = {
  message: string
  error?: {kind?: string; message?: string; stack?: string}
  http?: {url?: string}
}

const NOISE_PATTERNS = [
  /chrome-extension:\/\//,
  /moz-extension:\/\//,
  /safari-extension:\/\//,
  /ResizeObserver loop/,
  /Script error\./,
  /Non-Error promise rejection captured/,
  /AbortError/,
]

const THIRD_PARTY_HOSTS = [
  'googletagmanager.com',
  'google-analytics.com',
  'hubspot',
  'hs-scripts.com',
  'hsforms.net',
  'hsforms.com',
  'hs-analytics.net',
  'convertexperiments.com',
  'usercentrics',
  'dreamdata',
  'intercom',
]

const OWN_DOMAINS = ['getmoss.com', 'runmoss.run']

const STACK_HOST_PATTERN = /https?:\/\/([^/\s:)]+)/g

const isThirdPartyHost = (host: string): boolean => THIRD_PARTY_HOSTS.some((thirdParty) => host.includes(thirdParty))

const isThirdPartyStack = (stack: string): boolean => {
  const hosts = Array.from(stack.matchAll(STACK_HOST_PATTERN), (match) => match[1])

  return hosts.length > 0 && hosts.every(isThirdPartyHost)
}

const isOwnHost = (hostname: string): boolean =>
  OWN_DOMAINS.some((domain) => hostname === domain || hostname.endsWith(`.${domain}`))

const isForeignUrl = (url: string): boolean => {
  try {
    return !isOwnHost(new URL(url).hostname)
  } catch {
    return false
  }
}

export const shouldSendBrowserLog = (event: BrowserLogCandidate): boolean => {
  const {error, http} = event
  const text = [event.message, error?.kind, error?.message, error?.stack].join('\n')

  if (NOISE_PATTERNS.some((pattern) => pattern.test(text))) {
    return false
  }

  if (http?.url && isForeignUrl(http.url)) {
    return false
  }

  return !(error?.stack && isThirdPartyStack(error.stack))
}
